import React from 'react'
import { Foot } from '../Foot/Foot'
import TopBar from '../TopBar/TopBar'
import "./login.css"

const Login = () => {
  return (
    <>
      <TopBar />
    <div className='login'>
      
        <div className="topic">Login To Nairaland</div>
        <div className="subtopic">Login With Password</div>

        <form><div className="form1">
          <label htmlFor="name">User Name: </label><input type="text" id='name'  disabled /></div><div className="form1">
            <label htmlFor="password">Password: </label><input type="password" id='password' disabled /></div>
          
        <button> Login</button>
        </form>

        <div className="subtopic sec">Reset Your Password</div>

        
        <form>
          <div className="details">Please enter your email address and a link allowing you to reset your password would be emailed to you.</div><div className="form1"><label htmlFor="email">E-mail: </label><input style={{ 'background-color': "white" }} disabled type="email" id='email' /></div>
        <button>Submit</button></form>

      </div>
      <div className="loginfoot"><Foot /></div>
    </>
  
  )
}

export default Login